import {TuiRoot} from "@taiga-ui/core";
import {ChangeDetectionStrategy, Component, DestroyRef, inject, signal} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {EventsService} from './shared/services/events.service';
import {AuthService} from './shared/services/auth.service';
import {ToastrService} from 'ngx-toastr';
import {catchError, of} from 'rxjs';
import {PreloaderComponent} from './shared/components/preloader/preloader.component';
import {LoadingService} from './shared/services/loading.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, TuiRoot, PreloaderComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class App {
  eventsService = inject(EventsService);
  toastrService = inject(ToastrService);
  router = inject(Router)
  authService = inject(AuthService);
  destroyRef = inject(DestroyRef);
  loadingService = inject(LoadingService);

  ngOnInit(): void {
  }

  constructor() {
    this.InitToastr();
    this.AuthCheck();
  }

  AuthCheck() {
    if (this.authService.HasTokens()) {
      this.authService.GetMe().pipe(
        catchError(err => {
          this.eventsService.throwError();
          return of(null);
        })
      ).subscribe();
    } else {
      this.authService.CLearSession();
      if (!window.location.href.includes('/auth')) {
        this.router.navigate(['/auth']);
      }
    }
  }

  InitToastr() {
    this.eventsService.IsErrorChange$.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((res: any) => {
      if (res && this.eventsService.Error.status) {
        this.toastrService.error(this.eventsService.Error.text, "Ошибка!", {
          positionClass: "toast-bottom-center",
          titleClass: 'title-toast'
        });
      } else {
        this.toastrService.clear();
      }
    })

    this.eventsService.IsSuccessChange$.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((res) => {
      if (res && this.eventsService.Success.status) {
        this.toastrService.success(
          this.eventsService.Success.text,
          "Операция выполнена успешно",
          {
            positionClass: "toast-bottom-center",
            titleClass: 'title-toast'
          }
        );
      } else {
        this.toastrService.clear();
      }
    })
  }
}
